import { render } from "./BlFormFieldTextarea.vue?vue&type=template&id=163fcc74&scoped=true"
import script from "./BlFormFieldTextarea.vue?vue&type=script&lang=js"
export * from "./BlFormFieldTextarea.vue?vue&type=script&lang=js"

import "./BlFormFieldTextarea.vue?vue&type=style&index=0&id=163fcc74&scoped=true&lang=css"

import exportComponent from "/tmp/eb47f32b-990a-42a6-a461-0a5e6cce3094/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-163fcc74"]])

export default __exports__